<template>
    <div class="quickpay-payment-layout">
        <CompassBackForwardButton
            link="javascript:void(0)"
            :label="$t.__('common.actions.back_to_document')"
            type="secondary"
            back
            class="quickpay-payment-layout__back-button"
            @click="$emit('back')"
        />
        <div class="quickpay-payment-layout__content">
            <slot name="description" />
            <slot name="main-content" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.quickpay-payment-layout {
    min-height: 100vh;
    min-height: 100dvh;
    background: url(../ressources/logged/img/illustrations/payment/background-payment.png) center
        center/cover no-repeat;
    padding: var(--spacing-5);
    animation: fadeIn 0.5s ease-out;

    @media (max-width: 1023px) {
        background-image: url(../ressources/logged/img/illustrations/payment/background-payment-mobile.png);
    }

    &__back-button {
        margin: 0 0 var(--spacing-3);
    }

    &__content {
        min-height: calc(100dvh - 168px);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;

        @media (min-width: 1441px) {
            justify-content: center;
            gap: 152px;
        }

        @media (max-width: 1023px) {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: var(--spacing-3);
        }
    }

    @media (max-width: 1023px) {
        padding: var(--spacing-4);
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>
